module.exports = __webpack_public_path__ + "static/media/guadalupe_doradaplus.df891572.png";